"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAusbilder = isAusbilder;
exports.isAusbilderOrFachausbilder = isAusbilderOrFachausbilder;
exports.isAusbilderOrTrainer = isAusbilderOrTrainer;
exports.isAzubi = isAzubi;
exports.isFachausbilder = isFachausbilder;
exports.isTrainer = isTrainer;
exports.roles = void 0;
var roles = exports.roles = {
  AZUBI: 'azubi',
  AUSBILDER: 'ausbilder',
  TRAINER: 'trainer',
  FACHAUSBILDER: 'fachausbilder'
};
function isAzubi(role) {
  return role === roles.AZUBI;
}
function isAusbilderOrTrainer(role) {
  return isAusbilder(role) || isTrainer(role);
}
function isAusbilder(role) {
  return role === roles.AUSBILDER;
}
function isFachausbilder(role) {
  return role === roles.FACHAUSBILDER;
}
function isTrainer(role) {
  return role === roles.TRAINER;
}
function isAusbilderOrFachausbilder(role) {
  return isAusbilder(role) || isFachausbilder(role);
}